import { useState, useEffect, useRef } from 'react';
import '../App.css';
import '../Tabs.css';
import AutocompletePaginado from './AutocompletePaginado';
import 'rsuite/DatePicker/styles/index.css';
import { aplicarMascaraCpfCnpj } from '../utils/MaskUtils';
import { request } from '../utils/ApiUtils';
import Input from './Input';
import { showNotification } from '../utils/NotificationUtils';
import InputMonetary from './InputMonetary';
import Table from './Table';
import { formatToBRL } from '../utils/MonetaryUtils';
import SaveIcon from '@mui/icons-material/CheckCircle';
import { hasAnyRole } from '../utils/TokenUtils';
import { rolesMapping } from '../utils/RolesUtils';

function ContratoParcelaTab(props) {
    const [dataArray, setDataArray] = useState([]);
    const [pageData, setPageData] = useState([]);
    const [atualizandoTotais, setAtualizandoTotais] = useState(false);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState(null);

    const carregarDados = async (page = 0) => {
        if (props.contratoId)
            request(`contrato-parcela/${props.contratoId}/paginated?page=${page}&size=${100}`, {
                type: 'POST',
                body: JSON.stringify({}),
                callback: (data) => (
                    setPageData(data),
                    setDataArray(data.content),
                    setAtualizandoTotais(true),
                    props.findTotals()
                ),
                callbackError: (message) => setErro(message || 'Ocorreu um erro inesperado, tente novamente ou contate o suporte.'),
                finally: () => setCarregando(false)
            })
    };

    useEffect(() => {
        if (!atualizandoTotais) {
            carregarDados();
        }

        setAtualizandoTotais(false)
    }, [props.contratoId, props.refreshKey]);

    const atualizarParcela = async (parcela) => {
        request(`contrato-parcela/${parcela.id}`, {
            type: 'PUT',
            body: JSON.stringify(parcela),
            callback: (data) => {
                showNotification('Parcela atualizada', 'success');
                props.loadContrato && props.loadContrato();
                parcela.alterada = false;
                updateRowOnDataArray(parcela)
            },
            callbackError: (responseData, message) => {
                const errorsEmpty = !responseData?.errors || Object.keys(responseData?.errors).length === 0;

                if (responseData?.handledError) {
                    if (!errorsEmpty) {
                        Object.entries(responseData?.errors).forEach(([key, value]) => {

                            showNotification(value, 'error', 5000);
                        });
                    } else

                        if (responseData?.error) {
                            showNotification(responseData.error, 'error', 5000);
                        }
                } else {
                    showNotification('Não foi possível atualizar a parcela, revise os dados informados.', 'error');
                }
            }
        })
    }

    const footerTotals = () => (
        <div className="table-footer-totals">
            <h4><span className="table-footer-indicator table-footer-indicator-received" />{`Valor total recebido: ${formatToBRL(props.comissoes?.totalParcelasRecebido)}`}</h4>
            <h4><span className="table-footer-indicator table-footer-indicator-pending" />{`Valor total a receber: ${formatToBRL(props.comissoes?.totalParcelasAReceber)}`}</h4>
        </div>
    )

    const onChangeParcela = (parcela, value, field) => {
        const updatedItem  = { ...parcela, alterada: true };
        updatedItem[field] = value;

        updateRowOnDataArray(updatedItem)
    }

    const updateRowOnDataArray = (parcela) => {
        const updatedArray = dataArray.map((row) =>
            row.numero === parcela?.numero ? parcela : row
        );

        setDataArray(updatedArray);
    }

    const tableParams = {
        query: (page) => carregarDados(page),
        hasFooter: true,
        columns: [
            {
                label: "Nº Parcela",
                width: "15%",
                type: "input",
                disable: true,
                key: "numero"
            },
            {
                label: "Valor Parcela",
                width: "30%",
                widthValue: '45%',
                disabled: (parcela) => props?.contratoCancelado || parcela?.status?.statusFinalOk || !hasAnyRole(rolesMapping.admin),
                type: "input-decimal",
                onChange: (parcela, value) => onChangeParcela(parcela, value, 'valor'),
                css: "decimal",
                key: "valor"
            },
            {
                label: "Data Vencimento",
                width: "30%",
                widthValue: '45%',
                type: "date",
                disabled: (parcela) => props?.contratoCancelado || parcela?.status?.statusFinalOk || !hasAnyRole(rolesMapping.admin),
                onChange: (parcela, value) => onChangeParcela(parcela, value, 'dataVencimento'),
                key: "dataVencimento"
            },
            {
                label: "Status",
                width: "20%",
                type: "autocomplete",
                // key: "status.status",
                component: {
                    endpoint: "contratos/status",
                    parameters: {
                        disabled: props?.contratoCancelado,
                        disableClearable: true,
                        width: '100%',
                        bodyToSearch: { statusParcela: true },
                        getLabel: (parcela) => parcela.status || '',
                        onChange: (parcela, statusSelecionado) => onChangeParcela(parcela, statusSelecionado?.item, 'status'),
                        getValue: (parcela) => parcela.status,
                        inputStyle: (status) => (
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${status?.item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            }
                        ),
                        POST: true,
                        reload: !!carregando
                    },
                },
                footer: { startColumn: 3, colSpan: 2 },
                htmlFooter: () => footerTotals(),

            },
            {
                label: "Salvar",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<SaveIcon />),
                color: (parcela) => parcela.alterada ? 'orange' : 'green',
                onClick: (parcela) => atualizarParcela(parcela)
            }
        ]
    };

    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>

            <div className='row'>
                <Input id="numero"
                    value={props.contrato?.numero}
                    parameters={{ width: '12%', label: "Nº do Contrato*", disabled: true }} />

                <AutocompletePaginado label={"Cliente*"}

                    parameters={{
                        width: '30%',
                        disabled: true,
                        label:"Cliente*",
                        getLabel: ((item) => (item.nome + (item.documento ? ` - ${aplicarMascaraCpfCnpj(item.documento)}` : ''))),
                        value: props.contrato?.cliente,
                        title: (props.contrato?.cliente ? `Documento: ${props.contrato?.cliente.documento} 
                                \nTelefone: ${props.contrato?.cliente.telefone || ''} 
                                \nE-mail: ${props.contrato?.cliente.email || ''}
                                \nEndereço: ${props.contrato?.cliente?.endereco?.cidade} - ${props.contrato?.cliente?.endereco?.uf}`
                            : '')
                    }}
                    endpoint={"clientes/paginated"} />

                <InputMonetary id="honorarioInicial"
                    value={props.contrato?.honorarioInicial}
                    disabled={true}
                    width='15%' label="Honorarios Iniciais" />

                <InputMonetary id="comissaoCaptador"
                    value={props.comissoes?.comissaoCaptador}
                    disabled={true}
                    width='15%' label="Comissão captador" />

                <InputMonetary id="comissaoFechador"
                    value={props.comissoes?.comissaoFechador}
                    disabled={true}
                    width='15%' label="Comissão fechador" />
            </div>


            <Table params={tableParams} dataArray={dataArray} pageData={pageData} />
        </div>
    );
}

export default ContratoParcelaTab;
